module.exports = __webpack_public_path__ + "media/images/favicon-570a8d2c7d124fca1845879fd9ce47c7.ico";